import { render } from "./FormDanaBantuan.vue?vue&type=template&id=657c0750&ts=true"
import script from "./FormDanaBantuan.vue?vue&type=script&lang=ts"
export * from "./FormDanaBantuan.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__